module.exports = __webpack_public_path__ + "img/cart-plus.d093e58d.svg";